export default {
  Enter: 'Enter',
  Escape: 'Escape',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Tab: 'Tab'
};
//# sourceMappingURL=keyboardEvents.js.map